import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetLaundryRes } from "types/laundry"

import laundriesService from "api/laundriesService"

const useGetLaundryChangesHistory = (laundryId: number, enabled: boolean) => {
  return useQuery("laundry_changes_history", async () => {
    try {
      const res: AxiosResponse<IGetLaundryRes> = await laundriesService.getLaundryChangesHistory(laundryId)

      return res.data
    }  catch (err: any) {
      return err.response
    }
  }, { enabled })
}

export default useGetLaundryChangesHistory